<template>
  <div
    class="content-box max-w rounded overflow-hidden"
    :class="active ? 'shadow-md' : 'shadow'"
    @mouseover="active = true"
    @mouseleave="active = false"
    :style="{ ...size }"
  >
    <div v-if="title"
      class="-header _shadow"
      :style="{ background: colors.primary }"
    >
      <div class="-icon">
        <i :name="icon"></i>
      </div>
      <div class="-title">
        {{ title }}
      </div>
    </div>
    <div class="action-bar _shadow" v-if="actions">
      <div class="-top">
        <slot name="top" />
      </div>
      <div class="-main">
        <div class="-tools">
          <slot name="tools" />
        </div>
        <div class="-actions">
          <slot name="-actions">
            <template v-for="action in actions" >
              <vs-button
                v-if="action.name && action.handlers"
                class="action-buttons rounded overflow-hidden shadow"
                :class="[
                  ...action.classes,
                  action.disabler ? '-disabled' : ''
                ]"
                :key="action.name" @click="action.handlers.click"
                :disabled="action.disabler"
              >
                {{ action.title || action.name }}
              </vs-button>
            </template>
          </slot>
        </div>
      </div>
    </div>
    <div class="-body"
      :class="{ '_no-scroll': noScroll }"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { colors } from "@/constants/config";

export default {
  props: {
    icon: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: "",
    },
    actions: {
      type: Object,
      default: () => {
        return null;
      }
    },
    size: {
      type: Object,
      default: () => {
        return {
          height: "75vh"
        }
      }
    },
    "no-scroll": {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    active: false,
    colors
  })
}
</script>

<style lang="scss" scoped>
$shadow-lite: 0 3px 3px 0 rgba(75, 75, 75, 0.1) !important;

.content-box {
  width: 100%;
  min-height: 200px;
  transition: all ease-out 0.3s;

  & .-header {
    width: 100%;
    min-height: 40px;
    // background: hotpink;
    // background: #009688;
    display: inline-flex;
    align-items: center;
    padding: 8px 16px;

    &._shadow {
      box-shadow: $shadow-lite
    }

    & .-icon {
      & i {
        font-size: 1rem;
      }
    }

    & .-title {
      color: white;
      font-size: 1.1rem;
      letter-spacing: 0.2px;
      // font-weight: 500;
    }

  }

  & .action-bar {
    background: #efefef;
    width: 100%;

    &._shadow {
      box-shadow: $shadow-lite
    }

    & .-main {
      display: inline-flex;
      justify-content: space-between;
      width: 100%;
      border-bottom: 1px solid #eeeeee;

      & .-actions {
        width: 100%;
        min-height: 40px;
        display: inline-flex;
        align-items: center;
        justify-content: flex-end;
        padding: 8px 16px;

        & .action-buttons {
          padding: 6px 12px;
          background: floralwhite;
          margin: 0 5px;

          & .-disabled {
            background: grey;
          }
        }
      }

      & .-tools {
        width: 100%;
        padding: 8px 16px;
      }
    }
  }

  & .-body {
    overflow-y: scroll !important;
    height: calc(100% - 120px) !important;

    &._no-scroll {
      overflow-y: hidden !important;
    }
  }
}

</style>
